import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./PaymentPage.css";
import QR from "../../../qr.png"
import { Radius } from "lucide-react";
import e from "express";
import axios from "axios";
import { error } from "console";


export default function PaymentPage() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState<"Par rib" | "Fatourati">("Par rib");
  const [Popup , setPopup] = useState(false);
  const commandeId = localStorage.getItem("CommandeId");
    const [loading, setLoadings] = useState(false);

  const Terminer = async (e:any)=>{

    e.preventDefault();

    try{
          await axios.post(
            `${process.env.REACT_APP_PHP_APP_URL}/commande/update`,
            { IdCommande: commandeId ,
              MethodPayment: selected ,
             },
            { headers: { "Content-Type": "application/json" } }
          );
          setLoadings(true);
          setTimeout(() => {
          setLoadings(false);
            
          }, 2000);
        localStorage.removeItem("CommandeId");

          setPopup(true);


    }catch{
    }

  }
  
    const close=(e:any)=>{
    e.preventDefault();
    setPopup(false);
    const redirectUrl = localStorage.getItem("redirectAfterPayment") || "/visiteurs";
    localStorage.removeItem("redirectAfterPayment");
    navigate(redirectUrl);
  }

  const downloadFacture = async () => {
  try {
    setLoadings(true);

    await axios.post(
            `${process.env.REACT_APP_PHP_APP_URL}/commande/update`,
            { IdCommande: commandeId ,
              MethodPayment: selected ,
             },
            { headers: { "Content-Type": "application/json" } }
          );

  //   const url = window.URL.createObjectURL(new Blob([res.data]));
  //   const link = document.createElement("a");
  //   link.href = url;
  //   link.download = `Facture.pdf`;
  //   link.click();

  //   setLoadings(false);
  } catch (error) {
    // console.log(error);
    // setLoadings(false);
  }
};


  return (
    <>
                 <div className="panier-header">

                
                <div className="brand-title">
                    <h1>Wyn</h1>
                    <div className="title-underline"></div>
                </div>
                
                {/* <PanierChrono /> */}
            </div>
          {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ marginLeft: "27%", height: "250px", color: "#FFC400" }}
        >
          <div className="spinner-border custom-spinner" role="status"></div>
          <span className="loader-charg">Chargement..</span>
        </div>
      ) : (
        <div className="payment-container">
          <i
            className="bi bi-arrow-left"
            onClick={() => window.history.back()}
            style={{
              backgroundColor: "#f5f5f5ff",
              color: "black",
              borderRadius: "50%",
              padding: "2%",
              fontSize: "1rem",
              marginRight: "20%",
              cursor: "pointer",
            }}
          ></i>

          <h2>Choisir le mode de paiement</h2>
          <p>Sélectionnez votre méthode de paiement préférée</p>

          {/* === Banque === */}
          <div
            className={`payment-option ${selected === "Par rib" ? "active" : ""}`}
            onClick={() => setSelected("Par rib")}
          >
            <div className="option-header">
              <div className="icon">
                <i className="bi bi-bank"></i>
              </div>
              <div>
                <h3>Virement Bancaire</h3>
                <span>Paiement par RIB avec QR code</span>
              </div>
              <input type="radio" checked={selected === "Par rib"} readOnly />
            </div>

            {selected === "Par rib" && (
              <div className="option-body">
                <div className="bank-left">
                  <div className="qr-placeholder">
                    <img src={QR} alt="" />
                  </div>
                  <p style={{ fontFamily: "lato" }}>Scannez pour payer via Banque</p>
                  <p style={{ fontFamily: "lato" }} className="rib-mask">
                    RIB: **** **** **65 77
                  </p>
                </div>

                <div className="bank-right">
                  <p style={{ fontFamily: "lato" }}>
                    <b>Banque:</b> Banque Populaire
                  </p>
                  <p style={{ fontFamily: "lato" }}>
                    <b>RIB:</b> 007 780 0003102000302865 77
                  </p>
                </div>
              </div>
            )}
          </div>

          {/* === Fatourati === */}
          {/* <div
            className={`payment-option ${selected === "Fatourati" ? "active" : ""}`}
            onClick={() => setSelected("Fatourati")}
          >
            <div className="option-header">
              <div className="icon">
                <i className="bi bi-wallet2"></i>
              </div>
              <div>
                <h3>Fatourati</h3>
                <span>Paiement via le service Fatourati</span>
              </div>
              <input type="radio" checked={selected === "Fatourati"} readOnly />
            </div>

            {selected === "Fatourati" && (
              <div className="option-body">
                <div className="fatourati-box">
                  <b>Numéro de créancier Fatourati</b>
                  <div className="credit-number">123456789</div>

                  <p>
                    Rendez-vous dans n’importe quelle agence bancaire ou utilisez
                    votre application bancaire pour effectuer le paiement via
                    Fatourati.
                  </p>
                </div>
              </div>
            )}
          </div> */}

          {/* Button */}
            <button
              className="download-btn"
              style={{ fontFamily: "lato" }}
              onClick={Terminer}
            >
              Terminer <i className="bi bi-check-circle-fill"></i>
            </button>
          {/* {selected === "Par rib" ? (
          ) : (
            <button
              className="download-btn"
              style={{ fontFamily: "lato" }}
              onClick={Terminer}
            >
              <i className="bi bi-download"></i>Télécharger Facture
            </button>
          )} */}

          <p className="secure-msg" style={{ fontFamily: "lato" }}>
            🔒 Tous les paiements sont sécurisés et cryptés
          </p>
        </div>
      )}

      {/* Popup */}
      {Popup && (
        <div className="modal-overlay">
          <div className="modal-card">
            <div className="modal-header">
              <div className="check-circle">✓</div>
            </div>
            <div className="modal-body">
              <h2>Merci pour votre paiement !</h2>
              <p>Veuillez envoyer le reçu à l'adresse ci-dessous</p>
              <div className="info-box">
                <div className="info-row">
                  <div className="icon email">✉</div>
                  <div className="info-text">
                    <span className="label">EMAIL</span>
                    <span className="value">wyncontact.ma@gmail.com</span>
                  </div>
                </div>
              </div>
              <button className="confirm-btn" onClick={close}>
                Compris, merci !
              </button>
            </div>
          </div>
        </div>
      )}
    

    </>
  );
}
